import { delistingReasonAuth, delistingReasonAuto, delistingReasonDeflagged, delistingReasonScrapped } from '#delisting/constants';
import { isDelisted, RavRecord, scopeOf } from '#record/model';
import { useSubmissionOracle } from '#submission/oracle';
import { useOracle } from 'apprise-frontend-iam/authz/oracle';



export const useVesselOracle = () => {


    const logged = useOracle()
    const submissions = useSubmissionOracle()
   
    // to refine: interactive edits only from managers
    const can = {

        editAll: submissions.canAddNew,
        addFor: submissions.canAddFor
    }

    const self = {


        canAddNew: can.editAll

        ,

        canAddFor: can.addFor
        
        ,

        // any user that can create new vessels for a given tenant can patch an unscrapped one in the same tenant.
        canEdit: (record: RavRecord) => {

            const state = record.delisting?.reason !== delistingReasonScrapped && record.delisting?.reason !== delistingReasonDeflagged

            const canedit =  logged.hasNoTenant() || (scopeOf(record) === 'external' ? can.addFor(logged.tenant()) : can.addFor(record.tenant))
            const tenancy = logged.hasNoTenant() || logged.managesMultipleTenants() || (scopeOf(record) === 'external' ? true : logged.tenant() === record.tenant )

            return state && tenancy && canedit
        }

        ,

        // any user that can patch a vessel can delist an non-delisted one.s
        canDelist: (record: RavRecord) => {

            const state = !isDelisted(record) || [delistingReasonAuth,delistingReasonAuto].includes(record.delisting!.reason)

            return state && ( scopeOf(record) === 'rav' || logged.tenant() === record.tenant ) && self.canEdit(record)    // tenancy triggers here.
        }

        ,

         // any user that can add records can claim deflagged vessels from any tenant.
         // admins may also claim records delisted because vessels were scrapped.
        canClaim: (record: RavRecord ) => {

            const state = record.scope !== 'external' && record.delisting && (logged.isAdmin() ? record.delisting.reason !== delistingReasonScrapped : record.delisting.reason === delistingReasonDeflagged)

            return state && can.editAll()   // no tenancy here.

        }

        ,

         canMerge: (record: RavRecord ) => {

            const state = true //!isDelisted(record)

            return state && logged.isAdmin()

        }

    }

    return self
}